import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown, Map, ArrowRight } from "lucide-react";
import MapEmbed from "@/components/MapEmbed";

/**
 * Compact "appellation card" injected below any AI response or article that
 * mentions a known appellation. Collapsed by default (single row with name +
 * "Voir la carte") → expands to reveal the full EtOH iframe map + a link to
 * the full page.
 */
export default function AppellationInsight({ appellation, defaultOpen = false }) {
  const [open, setOpen] = useState(defaultOpen);
  if (!appellation?.name) return null;

  return (
    <div
      className="rounded-2xl border border-[#1F3A5F]/12 bg-white overflow-hidden"
      data-testid={`appellation-insight-${appellation.slug || appellation.name}`}
    >
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-[#FBF7F3] transition-colors"
        aria-expanded={open}
      >
        <div className="w-9 h-9 rounded-xl bg-[#FCE4ED] flex items-center justify-center shrink-0">
          <Map className="w-4 h-4 text-[#E5276A]" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-display text-base text-[#1F3A5F] leading-tight">
            {appellation.name}
          </div>
          <div className="text-[11px] text-[#8B95A1]">
            {[appellation.region, appellation.country].filter(Boolean).join(", ") || "Explorer sur la carte"}
          </div>
        </div>
        <ChevronDown
          className={`w-4 h-4 text-[#8B95A1] transition-transform ${open ? "rotate-180" : ""}`}
        />
      </button>
      {open && (
        <div className="border-t border-[#1F3A5F]/8 p-3 bg-[#FBF7F3]/50">
          <MapEmbed appellation={appellation.name} height={360} />
          <div className="mt-3 flex flex-wrap items-center gap-2">
            <Link
              to={`/appellations/${encodeURIComponent(appellation.slug || appellation.name)}`}
              className="inline-flex items-center gap-1.5 text-xs font-bold text-[#E5276A] hover:text-[#C01661]"
            >
              Voir la fiche complète <ArrowRight className="w-3 h-3" />
            </Link>
          </div>
        </div>
      )}
    </div>
  );
}
